import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconNoteSvg } from "./IconNoteSvg.mjs";
const IconNote = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconNoteSvg, ...iconProps });
};
export {
  IconNote
};
